import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        webshops: [],
        shop: null,
        statusCodes: [],
        countries: [],
        countryArr: [
            {
                "CountryId": 2,
                "CountryCode": "AL",
                "CountryName": "Albania",
                "PhoneCode": "355",
                "CountryCode3Letter": "ALB"
            },
            {
                "CountryId": 3,
                "CountryCode": "DZ",
                "CountryName": "Algeria",
                "PhoneCode": "213",
                "CountryCode3Letter": "DZA"
            },
            {
                "CountryId": 4,
                "CountryCode": "AS",
                "CountryName": "American Samoa",
                "PhoneCode": "1684",
                "CountryCode3Letter": "ASM"
            },
            {
                "CountryId": 5,
                "CountryCode": "AD",
                "CountryName": "Andorra",
                "PhoneCode": "376",
                "CountryCode3Letter": "AND"
            },
            {
                "CountryId": 6,
                "CountryCode": "AO",
                "CountryName": "Angola",
                "PhoneCode": "244",
                "CountryCode3Letter": "AGO"
            },
            {
                "CountryId": 7,
                "CountryCode": "AI",
                "CountryName": "Anguilla",
                "PhoneCode": "1264",
                "CountryCode3Letter": "AIA"
            },
            {
                "CountryId": 8,
                "CountryCode": "AQ",
                "CountryName": "Antarctica",
                "PhoneCode": null,
                "CountryCode3Letter": "ATA"
            },
            // {
            //     "CountryId": 9,
            //     "CountryCode": "AG",
            //     "CountryName": "Antigua and Barbuda",
            //     "PhoneCode": "1268",
            //     "CountryCode3Letter": "ATG"
            // },
            {
                "CountryId": 10,
                "CountryCode": "AR",
                "CountryName": "Argentina",
                "PhoneCode": "54",
                "CountryCode3Letter": "ARG"
            },
            {
                "CountryId": 11,
                "CountryCode": "AM",
                "CountryName": "Armenia",
                "PhoneCode": "374",
                "CountryCode3Letter": "ARM"
            },
            {
                "CountryId": 12,
                "CountryCode": "AW",
                "CountryName": "Aruba",
                "PhoneCode": "297",
                "CountryCode3Letter": "ABW"
            },
            {
                "CountryId": 13,
                "CountryCode": "AU",
                "CountryName": "Australia",
                "PhoneCode": "61",
                "CountryCode3Letter": "AUS"
            },
            {
                "CountryId": 14,
                "CountryCode": "AT",
                "CountryName": "Austria",
                "PhoneCode": "43",
                "CountryCode3Letter": "AUT"
            },
            {
                "CountryId": 15,
                "CountryCode": "AZ",
                "CountryName": "Azerbaijan",
                "PhoneCode": "994",
                "CountryCode3Letter": "AZE"
            },
            {
                "CountryId": 16,
                "CountryCode": "BS",
                "CountryName": "Bahamas",
                "PhoneCode": "1242",
                "CountryCode3Letter": "BHS"
            },
            {
                "CountryId": 17,
                "CountryCode": "BH",
                "CountryName": "Bahrain",
                "PhoneCode": "973",
                "CountryCode3Letter": "BHR"
            },
            {
                "CountryId": 18,
                "CountryCode": "BD",
                "CountryName": "Bangladesh",
                "PhoneCode": "880",
                "CountryCode3Letter": "BGD"
            },
            {
                "CountryId": 19,
                "CountryCode": "BB",
                "CountryName": "Barbados",
                "PhoneCode": "1246",
                "CountryCode3Letter": "BRB"
            },
            {
                "CountryId": 20,
                "CountryCode": "BY",
                "CountryName": "Belarus",
                "PhoneCode": "375",
                "CountryCode3Letter": "BLR"
            },
            {
                "CountryId": 21,
                "CountryCode": "BE",
                "CountryName": "Belgium",
                "PhoneCode": "32",
                "CountryCode3Letter": "BEL"
            },
            {
                "CountryId": 22,
                "CountryCode": "BZ",
                "CountryName": "Belize",
                "PhoneCode": "501",
                "CountryCode3Letter": "BLZ"
            },
            {
                "CountryId": 23,
                "CountryCode": "BJ",
                "CountryName": "Benin",
                "PhoneCode": "229",
                "CountryCode3Letter": "BEN"
            },
            {
                "CountryId": 24,
                "CountryCode": "BM",
                "CountryName": "Bermuda",
                "PhoneCode": "1441",
                "CountryCode3Letter": "BMU"
            },
            {
                "CountryId": 25,
                "CountryCode": "BT",
                "CountryName": "Bhutan",
                "PhoneCode": "975",
                "CountryCode3Letter": "BTN"
            },
            {
                "CountryId": 26,
                "CountryCode": "BO",
                "CountryName": "Bolivia",
                "PhoneCode": "591",
                "CountryCode3Letter": "BOL"
            },
            // {
            //     "CountryId": 27,
            //     "CountryCode": "BA",
            //     "CountryName": "Bosnia and Herzegovina",
            //     "PhoneCode": "387",
            //     "CountryCode3Letter": "BIH"
            // },
            {
                "CountryId": 28,
                "CountryCode": "BW",
                "CountryName": "Botswana",
                "PhoneCode": "267",
                "CountryCode3Letter": "BWA"
            },
            // {
            //     "CountryId": 29,
            //     "CountryCode": "BV",
            //     "CountryName": "Bouvet Island",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": "BVT"
            // },
            {
                "CountryId": 30,
                "CountryCode": "BR",
                "CountryName": "Brazil",
                "PhoneCode": "55",
                "CountryCode3Letter": "BRA"
            },
            // {
            //     "CountryId": 31,
            //     "CountryCode": "BQ",
            //     "CountryName": "British Antarctic Territory",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": "BES"
            // },
            // {
            //     "CountryId": 32,
            //     "CountryCode": "IO",
            //     "CountryName": "British Indian Ocean Territory",
            //     "PhoneCode": "246",
            //     "CountryCode3Letter": "IOT"
            // },
            // {
            //     "CountryId": 33,
            //     "CountryCode": "VG",
            //     "CountryName": "British Virgin Islands",
            //     "PhoneCode": "1284",
            //     "CountryCode3Letter": "VGB"
            // },
            {
                "CountryId": 34,
                "CountryCode": "BN",
                "CountryName": "Brunei",
                "PhoneCode": "673",
                "CountryCode3Letter": "BRN"
            },
            {
                "CountryId": 35,
                "CountryCode": "BG",
                "CountryName": "Bulgaria",
                "PhoneCode": "359",
                "CountryCode3Letter": "BGR"
            },
            // {
            //     "CountryId": 36,
            //     "CountryCode": "BF",
            //     "CountryName": "Burkina Faso",
            //     "PhoneCode": "226",
            //     "CountryCode3Letter": "BFA"
            // },
            {
                "CountryId": 37,
                "CountryCode": "BI",
                "CountryName": "Burundi",
                "PhoneCode": "257",
                "CountryCode3Letter": "BDI"
            },
            {
                "CountryId": 38,
                "CountryCode": "KH",
                "CountryName": "Cambodia",
                "PhoneCode": "855",
                "CountryCode3Letter": "KHM"
            },
            {
                "CountryId": 39,
                "CountryCode": "CM",
                "CountryName": "Cameroon",
                "PhoneCode": "237",
                "CountryCode3Letter": "CMR"
            },
            {
                "CountryId": 40,
                "CountryCode": "CA",
                "CountryName": "Canada",
                "PhoneCode": "1",
                "CountryCode3Letter": "CAN"
            },
            // {
            //     "CountryId": 41,
            //     "CountryCode": "CT",
            //     "CountryName": "Canton and Enderbury Islands",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": null
            // },
            // {
            //     "CountryId": 42,
            //     "CountryCode": "CV",
            //     "CountryName": "Cape Verde",
            //     "PhoneCode": "238",
            //     "CountryCode3Letter": "CPV"
            // },
            // {
            //     "CountryId": 43,
            //     "CountryCode": "KY",
            //     "CountryName": "Cayman Islands",
            //     "PhoneCode": "1345",
            //     "CountryCode3Letter": "CYM"
            // },
            // {
            //     "CountryId": 44,
            //     "CountryCode": "CF",
            //     "CountryName": "Central African Republic",
            //     "PhoneCode": "236",
            //     "CountryCode3Letter": "CAF"
            // },
            {
                "CountryId": 45,
                "CountryCode": "TD",
                "CountryName": "Chad",
                "PhoneCode": "235",
                "CountryCode3Letter": "TCD"
            },
            {
                "CountryId": 46,
                "CountryCode": "CL",
                "CountryName": "Chile",
                "PhoneCode": "56",
                "CountryCode3Letter": "CHL"
            },
            {
                "CountryId": 47,
                "CountryCode": "CN",
                "CountryName": "China",
                "PhoneCode": "86",
                "CountryCode3Letter": "CHN"
            },
            // {
            //     "CountryId": 48,
            //     "CountryCode": "CX",
            //     "CountryName": "Christmas Island",
            //     "PhoneCode": "61",
            //     "CountryCode3Letter": "CXR"
            // },
            // {
            //     "CountryId": 49,
            //     "CountryCode": "CC",
            //     "CountryName": "Cocos [Keeling] Islands",
            //     "PhoneCode": "61",
            //     "CountryCode3Letter": "CCK"
            // },
            {
                "CountryId": 50,
                "CountryCode": "CO",
                "CountryName": "Colombia",
                "PhoneCode": "57",
                "CountryCode3Letter": "COL"
            },
            {
                "CountryId": 51,
                "CountryCode": "KM",
                "CountryName": "Comoros",
                "PhoneCode": "269",
                "CountryCode3Letter": "COM"
            },
            // {
            //     "CountryId": 52,
            //     "CountryCode": "CG",
            //     "CountryName": "Congo - Brazzaville",
            //     "PhoneCode": "242",
            //     "CountryCode3Letter": "COG"
            // },
            // {
            //     "CountryId": 53,
            //     "CountryCode": "CD",
            //     "CountryName": "Congo - Kinshasa",
            //     "PhoneCode": "243",
            //     "CountryCode3Letter": "COD"
            // },
            // {
            //     "CountryId": 54,
            //     "CountryCode": "CK",
            //     "CountryName": "Cook Islands",
            //     "PhoneCode": "682",
            //     "CountryCode3Letter": "COK"
            // },
            // {
            //     "CountryId": 55,
            //     "CountryCode": "CR",
            //     "CountryName": "Costa Rica",
            //     "PhoneCode": "506",
            //     "CountryCode3Letter": "CRI"
            // },
            {
                "CountryId": 56,
                "CountryCode": "HR",
                "CountryName": "Croatia",
                "PhoneCode": "385",
                "CountryCode3Letter": "HRV"
            },
            {
                "CountryId": 57,
                "CountryCode": "CU",
                "CountryName": "Cuba",
                "PhoneCode": "53",
                "CountryCode3Letter": "CUB"
            },
            {
                "CountryId": 58,
                "CountryCode": "CY",
                "CountryName": "Cyprus",
                "PhoneCode": "357",
                "CountryCode3Letter": "CYP"
            },
            // {
            //     "CountryId": 59,
            //     "CountryCode": "CZ",
            //     "CountryName": "Czech Republic",
            //     "PhoneCode": "420",
            //     "CountryCode3Letter": "CZE"
            // },
            // {
            //     "CountryId": 60,
            //     "CountryCode": "CI",
            //     "CountryName": "Côte d’Ivoire",
            //     "PhoneCode": "225",
            //     "CountryCode3Letter": "CIV"
            // },
            {
                "CountryId": 61,
                "CountryCode": "DK",
                "CountryName": "Denmark",
                "PhoneCode": "45",
                "CountryCode3Letter": "DNK"
            },
            {
                "CountryId": 62,
                "CountryCode": "DJ",
                "CountryName": "Djibouti",
                "PhoneCode": "253",
                "CountryCode3Letter": "DJI"
            },
            {
                "CountryId": 63,
                "CountryCode": "DM",
                "CountryName": "Dominica",
                "PhoneCode": "1767",
                "CountryCode3Letter": "DMA"
            },
            // {
            //     "CountryId": 64,
            //     "CountryCode": "DO",
            //     "CountryName": "Dominican Republic",
            //     "PhoneCode": "1849",
            //     "CountryCode3Letter": "DOM"
            // },
            {
                "CountryId": 65,
                "CountryCode": "NQ",
                "CountryName": "Dronning Maud Land",
                "PhoneCode": null,
                "CountryCode3Letter": null
            },
            {
                "CountryId": 67,
                "CountryCode": "EC",
                "CountryName": "Ecuador",
                "PhoneCode": "593",
                "CountryCode3Letter": "ECU"
            },
            {
                "CountryId": 68,
                "CountryCode": "EG",
                "CountryName": "Egypt",
                "PhoneCode": "20",
                "CountryCode3Letter": "EGY"
            },
            // {
            //     "CountryId": 69,
            //     "CountryCode": "SV",
            //     "CountryName": "El Salvador",
            //     "PhoneCode": "503",
            //     "CountryCode3Letter": "SLV"
            // },
            // {
            //     "CountryId": 70,
            //     "CountryCode": "GQ",
            //     "CountryName": "Equatorial Guinea",
            //     "PhoneCode": "240",
            //     "CountryCode3Letter": "GNQ"
            // },
            {
                "CountryId": 71,
                "CountryCode": "ER",
                "CountryName": "Eritrea",
                "PhoneCode": "291",
                "CountryCode3Letter": "ERI"
            },
            {
                "CountryId": 72,
                "CountryCode": "EE",
                "CountryName": "Estonia",
                "PhoneCode": "372",
                "CountryCode3Letter": "EST"
            },
            {
                "CountryId": 73,
                "CountryCode": "ET",
                "CountryName": "Ethiopia",
                "PhoneCode": "251",
                "CountryCode3Letter": "ETH"
            },
            // {
            //     "CountryId": 74,
            //     "CountryCode": "FK",
            //     "CountryName": "Falkland Islands",
            //     "PhoneCode": "500",
            //     "CountryCode3Letter": "FLK"
            // },
            // {
            //     "CountryId": 75,
            //     "CountryCode": "FO",
            //     "CountryName": "Faroe Islands",
            //     "PhoneCode": "298",
            //     "CountryCode3Letter": "FRO"
            // },
            {
                "CountryId": 76,
                "CountryCode": "FJ",
                "CountryName": "Fiji",
                "PhoneCode": "679",
                "CountryCode3Letter": "FJI"
            },
            {
                "CountryId": 77,
                "CountryCode": "FI",
                "CountryName": "Finland",
                "PhoneCode": "358",
                "CountryCode3Letter": "FIN"
            },
            {
                "CountryId": 78,
                "CountryCode": "FR",
                "CountryName": "France",
                "PhoneCode": "33",
                "CountryCode3Letter": "FRA"
            },
            // {
            //     "CountryId": 79,
            //     "CountryCode": "GF",
            //     "CountryName": "French Guiana",
            //     "PhoneCode": "594",
            //     "CountryCode3Letter": "GUF"
            // },
            // {
            //     "CountryId": 80,
            //     "CountryCode": "PF",
            //     "CountryName": "French Polynesia",
            //     "PhoneCode": "689",
            //     "CountryCode3Letter": "PYF"
            // },
            // {
            //     "CountryId": 81,
            //     "CountryCode": "TF",
            //     "CountryName": "French Southern Territories",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": "ATF"
            // },
            // {
            //     "CountryId": 82,
            //     "CountryCode": "FQ",
            //     "CountryName": "French Southern and Antarctic Territories",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": null
            // },
            {
                "CountryId": 83,
                "CountryCode": "GA",
                "CountryName": "Gabon",
                "PhoneCode": "241",
                "CountryCode3Letter": "GAB"
            },
            {
                "CountryId": 84,
                "CountryCode": "GM",
                "CountryName": "Gambia",
                "PhoneCode": "220",
                "CountryCode3Letter": "GMB"
            },
            {
                "CountryId": 85,
                "CountryCode": "GE",
                "CountryName": "Georgia",
                "PhoneCode": "995",
                "CountryCode3Letter": "GEO"
            },
            {
                "CountryId": 86,
                "CountryCode": "DE",
                "CountryName": "Germany",
                "PhoneCode": "49",
                "CountryCode3Letter": "DEU"
            },
            {
                "CountryId": 87,
                "CountryCode": "GH",
                "CountryName": "Ghana",
                "PhoneCode": "233",
                "CountryCode3Letter": "GHA"
            },
            {
                "CountryId": 88,
                "CountryCode": "GI",
                "CountryName": "Gibraltar",
                "PhoneCode": "350",
                "CountryCode3Letter": "GIB"
            },
            {
                "CountryId": 89,
                "CountryCode": "GR",
                "CountryName": "Greece",
                "PhoneCode": "30",
                "CountryCode3Letter": "GRC"
            },
            {
                "CountryId": 90,
                "CountryCode": "GL",
                "CountryName": "Greenland",
                "PhoneCode": "299",
                "CountryCode3Letter": "GRL"
            },
            {
                "CountryId": 91,
                "CountryCode": "GD",
                "CountryName": "Grenada",
                "PhoneCode": "1473",
                "CountryCode3Letter": "GRD"
            },
            {
                "CountryId": 92,
                "CountryCode": "GP",
                "CountryName": "Guadeloupe",
                "PhoneCode": "590",
                "CountryCode3Letter": "GLP"
            },
            {
                "CountryId": 93,
                "CountryCode": "GU",
                "CountryName": "Guam",
                "PhoneCode": "1671",
                "CountryCode3Letter": "GUM"
            },
            {
                "CountryId": 94,
                "CountryCode": "GT",
                "CountryName": "Guatemala",
                "PhoneCode": "502",
                "CountryCode3Letter": "GTM"
            },
            {
                "CountryId": 95,
                "CountryCode": "GG",
                "CountryName": "Guernsey",
                "PhoneCode": "44",
                "CountryCode3Letter": "GGY"
            },
            {
                "CountryId": 96,
                "CountryCode": "GN",
                "CountryName": "Guinea",
                "PhoneCode": "224",
                "CountryCode3Letter": "GIN"
            },
            {
                "CountryId": 97,
                "CountryCode": "GW",
                "CountryName": "Guinea-Bissau",
                "PhoneCode": "245",
                "CountryCode3Letter": "GNB"
            },
            {
                "CountryId": 98,
                "CountryCode": "GY",
                "CountryName": "Guyana",
                "PhoneCode": "592",
                "CountryCode3Letter": "GUY"
            },
            {
                "CountryId": 99,
                "CountryCode": "HT",
                "CountryName": "Haiti",
                "PhoneCode": "509",
                "CountryCode3Letter": "HTI"
            },
            // {
            //     "CountryId": 100,
            //     "CountryCode": "HM",
            //     "CountryName": "Heard Island and McDonald Islands",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": "HMD"
            // },
            {
                "CountryId": 101,
                "CountryCode": "HN",
                "CountryName": "Honduras",
                "PhoneCode": "504",
                "CountryCode3Letter": "HND"
            },
            // {
            //     "CountryId": 102,
            //     "CountryCode": "HK",
            //     "CountryName": "Hong Kong SAR China",
            //     "PhoneCode": "852",
            //     "CountryCode3Letter": "HKG"
            // },
            {
                "CountryId": 103,
                "CountryCode": "HU",
                "CountryName": "Hungary",
                "PhoneCode": "36",
                "CountryCode3Letter": "HUN"
            },
            {
                "CountryId": 104,
                "CountryCode": "IS",
                "CountryName": "Iceland",
                "PhoneCode": "354",
                "CountryCode3Letter": "ISL"
            },
            {
                "CountryId": 105,
                "CountryCode": "IN",
                "CountryName": "India",
                "PhoneCode": "91",
                "CountryCode3Letter": "IND"
            },
            {
                "CountryId": 106,
                "CountryCode": "ID",
                "CountryName": "Indonesia",
                "PhoneCode": "62",
                "CountryCode3Letter": "IDN"
            },
            {
                "CountryId": 107,
                "CountryCode": "IR",
                "CountryName": "Iran",
                "PhoneCode": "98",
                "CountryCode3Letter": "IRN"
            },
            {
                "CountryId": 108,
                "CountryCode": "IQ",
                "CountryName": "Iraq",
                "PhoneCode": "964",
                "CountryCode3Letter": "IRQ"
            },
            {
                "CountryId": 109,
                "CountryCode": "IE",
                "CountryName": "Ireland",
                "PhoneCode": "353",
                "CountryCode3Letter": "IRL"
            },
            // {
            //     "CountryId": 110,
            //     "CountryCode": "IM",
            //     "CountryName": "Isle of Man",
            //     "PhoneCode": "44",
            //     "CountryCode3Letter": "IMN"
            // },
            {
                "CountryId": 111,
                "CountryCode": "IL",
                "CountryName": "Israel",
                "PhoneCode": "972",
                "CountryCode3Letter": "ISR"
            },
            {
                "CountryId": 112,
                "CountryCode": "IT",
                "CountryName": "Italy",
                "PhoneCode": "39",
                "CountryCode3Letter": "ITA"
            },
            {
                "CountryId": 113,
                "CountryCode": "JM",
                "CountryName": "Jamaica",
                "PhoneCode": "1876",
                "CountryCode3Letter": "JAM"
            },
            {
                "CountryId": 114,
                "CountryCode": "JP",
                "CountryName": "Japan",
                "PhoneCode": "81",
                "CountryCode3Letter": "JPN"
            },
            {
                "CountryId": 115,
                "CountryCode": "JE",
                "CountryName": "Jersey",
                "PhoneCode": "44",
                "CountryCode3Letter": "JEY"
            },
            // {
            //     "CountryId": 116,
            //     "CountryCode": "JT",
            //     "CountryName": "Johnston Island",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": null
            // },
            {
                "CountryId": 117,
                "CountryCode": "JO",
                "CountryName": "Jordan",
                "PhoneCode": "962",
                "CountryCode3Letter": "JOR"
            },
            {
                "CountryId": 118,
                "CountryCode": "KZ",
                "CountryName": "Kazakhstan",
                "PhoneCode": "77",
                "CountryCode3Letter": "KAZ"
            },
            {
                "CountryId": 119,
                "CountryCode": "KE",
                "CountryName": "Kenya",
                "PhoneCode": "254",
                "CountryCode3Letter": "KEN"
            },
            {
                "CountryId": 120,
                "CountryCode": "KI",
                "CountryName": "Kiribati",
                "PhoneCode": "686",
                "CountryCode3Letter": "KIR"
            },
            {
                "CountryId": 121,
                "CountryCode": "KW",
                "CountryName": "Kuwait",
                "PhoneCode": "965",
                "CountryCode3Letter": "KWT"
            },
            {
                "CountryId": 122,
                "CountryCode": "KG",
                "CountryName": "Kyrgyzstan",
                "PhoneCode": "996",
                "CountryCode3Letter": "KGZ"
            },
            {
                "CountryId": 123,
                "CountryCode": "LA",
                "CountryName": "Laos",
                "PhoneCode": "856",
                "CountryCode3Letter": "LAO"
            },
            {
                "CountryId": 124,
                "CountryCode": "LV",
                "CountryName": "Latvia",
                "PhoneCode": "371",
                "CountryCode3Letter": "LVA"
            },
            {
                "CountryId": 125,
                "CountryCode": "LB",
                "CountryName": "Lebanon",
                "PhoneCode": "961",
                "CountryCode3Letter": "LBN"
            },
            {
                "CountryId": 126,
                "CountryCode": "LS",
                "CountryName": "Lesotho",
                "PhoneCode": "266",
                "CountryCode3Letter": "LSO"
            },
            {
                "CountryId": 127,
                "CountryCode": "LR",
                "CountryName": "Liberia",
                "PhoneCode": "231",
                "CountryCode3Letter": "LBR"
            },
            {
                "CountryId": 128,
                "CountryCode": "LY",
                "CountryName": "Libya",
                "PhoneCode": "218",
                "CountryCode3Letter": "LBY"
            },
            {
                "CountryId": 129,
                "CountryCode": "LI",
                "CountryName": "Liechtenstein",
                "PhoneCode": "423",
                "CountryCode3Letter": "LIE"
            },
            {
                "CountryId": 130,
                "CountryCode": "LT",
                "CountryName": "Lithuania",
                "PhoneCode": "370",
                "CountryCode3Letter": "LTU"
            },
            {
                "CountryId": 131,
                "CountryCode": "LU",
                "CountryName": "Luxembourg",
                "PhoneCode": "352",
                "CountryCode3Letter": "LUX"
            },
            {
                "CountryId": 132,
                "CountryCode": "MO",
                "CountryName": "Macau SAR China",
                "PhoneCode": "853",
                "CountryCode3Letter": "MAC"
            },
            {
                "CountryId": 133,
                "CountryCode": "MK",
                "CountryName": "Macedonia",
                "PhoneCode": "389",
                "CountryCode3Letter": "MKD"
            },
            {
                "CountryId": 134,
                "CountryCode": "MG",
                "CountryName": "Madagascar",
                "PhoneCode": "261",
                "CountryCode3Letter": "MDG"
            },
            {
                "CountryId": 135,
                "CountryCode": "MW",
                "CountryName": "Malawi",
                "PhoneCode": "265",
                "CountryCode3Letter": "MWI"
            },
            {
                "CountryId": 136,
                "CountryCode": "MY",
                "CountryName": "Malaysia",
                "PhoneCode": "60",
                "CountryCode3Letter": "MYS"
            },
            {
                "CountryId": 137,
                "CountryCode": "MV",
                "CountryName": "Maldives",
                "PhoneCode": "960",
                "CountryCode3Letter": "MDV"
            },
            {
                "CountryId": 138,
                "CountryCode": "ML",
                "CountryName": "Mali",
                "PhoneCode": "223",
                "CountryCode3Letter": "MLI"
            },
            {
                "CountryId": 139,
                "CountryCode": "MT",
                "CountryName": "Malta",
                "PhoneCode": "356",
                "CountryCode3Letter": "MLT"
            },
            // {
            //     "CountryId": 140,
            //     "CountryCode": "MH",
            //     "CountryName": "Marshall Islands",
            //     "PhoneCode": "692",
            //     "CountryCode3Letter": "MHL"
            // },
            {
                "CountryId": 141,
                "CountryCode": "MQ",
                "CountryName": "Martinique",
                "PhoneCode": "596",
                "CountryCode3Letter": "MTQ"
            },
            {
                "CountryId": 142,
                "CountryCode": "MR",
                "CountryName": "Mauritania",
                "PhoneCode": "222",
                "CountryCode3Letter": "MRT"
            },
            {
                "CountryId": 143,
                "CountryCode": "MU",
                "CountryName": "Mauritius",
                "PhoneCode": "230",
                "CountryCode3Letter": "MUS"
            },
            // {
            //     "CountryId": 144,
            //     "CountryCode": "YT",
            //     "CountryName": "Mayotte",
            //     "PhoneCode": "262",
            //     "CountryCode3Letter": "MYT"
            // },
            // {
            //     "CountryId": 145,
            //     "CountryCode": "FX",
            //     "CountryName": "Metropolitan France",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": null
            // },
            {
                "CountryId": 146,
                "CountryCode": "MX",
                "CountryName": "Mexico",
                "PhoneCode": "52",
                "CountryCode3Letter": "MEX"
            },
            {
                "CountryId": 147,
                "CountryCode": "FM",
                "CountryName": "Micronesia",
                "PhoneCode": "691",
                "CountryCode3Letter": "FSM"
            },
            // {
            //     "CountryId": 148,
            //     "CountryCode": "MI",
            //     "CountryName": "Midway Islands",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": null
            // },
            {
                "CountryId": 149,
                "CountryCode": "MD",
                "CountryName": "Moldova",
                "PhoneCode": "373",
                "CountryCode3Letter": "MDA"
            },
            {
                "CountryId": 150,
                "CountryCode": "MC",
                "CountryName": "Monaco",
                "PhoneCode": "377",
                "CountryCode3Letter": "MCO"
            },
            {
                "CountryId": 151,
                "CountryCode": "MN",
                "CountryName": "Mongolia",
                "PhoneCode": "976",
                "CountryCode3Letter": "MNG"
            },
            {
                "CountryId": 152,
                "CountryCode": "ME",
                "CountryName": "Montenegro",
                "PhoneCode": "382",
                "CountryCode3Letter": "MNE"
            },
            {
                "CountryId": 153,
                "CountryCode": "MS",
                "CountryName": "Montserrat",
                "PhoneCode": "1664",
                "CountryCode3Letter": "MSR"
            },
            {
                "CountryId": 154,
                "CountryCode": "MA",
                "CountryName": "Morocco",
                "PhoneCode": "212",
                "CountryCode3Letter": "MAR"
            },
            {
                "CountryId": 155,
                "CountryCode": "MZ",
                "CountryName": "Mozambique",
                "PhoneCode": "258",
                "CountryCode3Letter": "MOZ"
            },
            {
                "CountryId": 156,
                "CountryCode": "MM",
                "CountryName": "Myanmar [Burma]",
                "PhoneCode": "95",
                "CountryCode3Letter": "MMR"
            },
            {
                "CountryId": 157,
                "CountryCode": "NA",
                "CountryName": "Namibia",
                "PhoneCode": "264",
                "CountryCode3Letter": "NAM"
            },
            {
                "CountryId": 158,
                "CountryCode": "NR",
                "CountryName": "Nauru",
                "PhoneCode": "674",
                "CountryCode3Letter": "NRU"
            },
            {
                "CountryId": 159,
                "CountryCode": "NP",
                "CountryName": "Nepal",
                "PhoneCode": "977",
                "CountryCode3Letter": "NPL"
            },
            {
                "CountryId": 160,
                "CountryCode": "NL",
                "CountryName": "Netherlands",
                "PhoneCode": "31",
                "CountryCode3Letter": "NLD"
            },
            {
                "CountryId": 161,
                "CountryCode": "AN",
                "CountryName": "Netherlands Antilles",
                "PhoneCode": null,
                "CountryCode3Letter": null
            },
            // {
            //     "CountryId": 162,
            //     "CountryCode": "NT",
            //     "CountryName": "Neutral Zone",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": null
            // },
            // {
            //     "CountryId": 163,
            //     "CountryCode": "NC",
            //     "CountryName": "New Caledonia",
            //     "PhoneCode": "687",
            //     "CountryCode3Letter": "NCL"
            // },
            // {
            //     "CountryId": 164,
            //     "CountryCode": "NZ",
            //     "CountryName": "New Zealand",
            //     "PhoneCode": "64",
            //     "CountryCode3Letter": "NZL"
            // },
            {
                "CountryId": 165,
                "CountryCode": "NI",
                "CountryName": "Nicaragua",
                "PhoneCode": "505",
                "CountryCode3Letter": "NIC"
            },
            {
                "CountryId": 166,
                "CountryCode": "NE",
                "CountryName": "Niger",
                "PhoneCode": "227",
                "CountryCode3Letter": "NER"
            },
            {
                "CountryId": 167,
                "CountryCode": "NG",
                "CountryName": "Nigeria",
                "PhoneCode": "234",
                "CountryCode3Letter": "NGA"
            },
            // {
            //     "CountryId": 168,
            //     "CountryCode": "NU",
            //     "CountryName": "Niue",
            //     "PhoneCode": "683",
            //     "CountryCode3Letter": "NIU"
            // },
            // {
            //     "CountryId": 169,
            //     "CountryCode": "NF",
            //     "CountryName": "Norfolk Island",
            //     "PhoneCode": "672",
            //     "CountryCode3Letter": "NFK"
            // },
            // {
            //     "CountryId": 170,
            //     "CountryCode": "KP",
            //     "CountryName": "North Korea",
            //     "PhoneCode": "850",
            //     "CountryCode3Letter": "PRK"
            // },
            // {
            //     "CountryId": 171,
            //     "CountryCode": "VD",
            //     "CountryName": "North Vietnam",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": null
            // },
            // {
            //     "CountryId": 172,
            //     "CountryCode": "MP",
            //     "CountryName": "Northern Mariana Islands",
            //     "PhoneCode": "1670",
            //     "CountryCode3Letter": "MNP"
            // },
            {
                "CountryId": 173,
                "CountryCode": "NO",
                "CountryName": "Norway",
                "PhoneCode": "47",
                "CountryCode3Letter": "NOR"
            },
            {
                "CountryId": 174,
                "CountryCode": "OM",
                "CountryName": "Oman",
                "PhoneCode": "968",
                "CountryCode3Letter": "OMN"
            },
            // {
            //     "CountryId": 175,
            //     "CountryCode": "PC",
            //     "CountryName": "Pacific Islands Trust Territory",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": null
            // },
            {
                "CountryId": 176,
                "CountryCode": "PK",
                "CountryName": "Pakistan",
                "PhoneCode": "92",
                "CountryCode3Letter": "PAK"
            },
            {
                "CountryId": 177,
                "CountryCode": "PW",
                "CountryName": "Palau",
                "PhoneCode": "680",
                "CountryCode3Letter": "PLW"
            },
            // {
            //     "CountryId": 178,
            //     "CountryCode": "PS",
            //     "CountryName": "Palestinian Territories",
            //     "PhoneCode": "970",
            //     "CountryCode3Letter": "PSE"
            // },
            {
                "CountryId": 179,
                "CountryCode": "PA",
                "CountryName": "Panama",
                "PhoneCode": "507",
                "CountryCode3Letter": "PAN"
            },
            {
                "CountryId": 180,
                "CountryCode": "PZ",
                "CountryName": "Panama Canal Zone",
                "PhoneCode": null,
                "CountryCode3Letter": null
            },
            // {
            //     "CountryId": 181,
            //     "CountryCode": "PG",
            //     "CountryName": "Papua New Guinea",
            //     "PhoneCode": "675",
            //     "CountryCode3Letter": "PNG"
            // },
            {
                "CountryId": 182,
                "CountryCode": "PY",
                "CountryName": "Paraguay",
                "PhoneCode": "595",
                "CountryCode3Letter": "PRY"
            },
            // {
            //     "CountryId": 183,
            //     "CountryCode": "YD",
            //     "CountryName": "People's Democratic Republic of Yemen",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": null
            // },
            {
                "CountryId": 184,
                "CountryCode": "PE",
                "CountryName": "Peru",
                "PhoneCode": "51",
                "CountryCode3Letter": "PER"
            },
            {
                "CountryId": 185,
                "CountryCode": "PH",
                "CountryName": "Philippines",
                "PhoneCode": "63",
                "CountryCode3Letter": "PHL"
            },
            // {
            //     "CountryId": 186,
            //     "CountryCode": "PN",
            //     "CountryName": "Pitcairn Islands",
            //     "PhoneCode": "64",
            //     "CountryCode3Letter": "PCN"
            // },
            {
                "CountryId": 187,
                "CountryCode": "PL",
                "CountryName": "Poland",
                "PhoneCode": "48",
                "CountryCode3Letter": "POL"
            },
            {
                "CountryId": 188,
                "CountryCode": "PT",
                "CountryName": "Portugal",
                "PhoneCode": "351",
                "CountryCode3Letter": "PRT"
            },
            // {
            //     "CountryId": 189,
            //     "CountryCode": "PR",
            //     "CountryName": "Puerto Rico",
            //     "PhoneCode": "1939",
            //     "CountryCode3Letter": "PRI"
            // },
            {
                "CountryId": 190,
                "CountryCode": "QA",
                "CountryName": "Qatar",
                "PhoneCode": "974",
                "CountryCode3Letter": "QAT"
            },
            {
                "CountryId": 191,
                "CountryCode": "RO",
                "CountryName": "Romania",
                "PhoneCode": "40",
                "CountryCode3Letter": "ROU"
            },
            {
                "CountryId": 192,
                "CountryCode": "RU",
                "CountryName": "Russia",
                "PhoneCode": "7",
                "CountryCode3Letter": "RUS"
            },
            {
                "CountryId": 193,
                "CountryCode": "RW",
                "CountryName": "Rwanda",
                "PhoneCode": "250",
                "CountryCode3Letter": "RWA"
            },
            // {
            //     "CountryId": 194,
            //     "CountryCode": "RE",
            //     "CountryName": "Réunion",
            //     "PhoneCode": "262",
            //     "CountryCode3Letter": "REU"
            // },
            // {
            //     "CountryId": 195,
            //     "CountryCode": "BL",
            //     "CountryName": "Saint Barthélemy",
            //     "PhoneCode": "590",
            //     "CountryCode3Letter": "BLM"
            // },
            // {
            //     "CountryId": 196,
            //     "CountryCode": "SH",
            //     "CountryName": "Saint Helena",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": "SHN"
            // },
            // {
            //     "CountryId": 197,
            //     "CountryCode": "KN",
            //     "CountryName": "Saint Kitts and Nevis",
            //     "PhoneCode": "1869",
            //     "CountryCode3Letter": "KNA"
            // },
            // {
            //     "CountryId": 198,
            //     "CountryCode": "LC",
            //     "CountryName": "Saint Lucia",
            //     "PhoneCode": "1758",
            //     "CountryCode3Letter": "LCA"
            // },
            // {
            //     "CountryId": 199,
            //     "CountryCode": "MF",
            //     "CountryName": "Saint Martin",
            //     "PhoneCode": "590",
            //     "CountryCode3Letter": "MAF"
            // },
            // {
            //     "CountryId": 200,
            //     "CountryCode": "PM",
            //     "CountryName": "Saint Pierre and Miquelon",
            //     "PhoneCode": "508",
            //     "CountryCode3Letter": "SPM"
            // },
            // {
            //     "CountryId": 201,
            //     "CountryCode": "VC",
            //     "CountryName": "Saint Vincent and the Grenadines",
            //     "PhoneCode": "1784",
            //     "CountryCode3Letter": "VCT"
            // },
            {
                "CountryId": 202,
                "CountryCode": "WS",
                "CountryName": "Samoa",
                "PhoneCode": "685",
                "CountryCode3Letter": "WSM"
            },
            // {
            //     "CountryId": 203,
            //     "CountryCode": "SM",
            //     "CountryName": "San Marino",
            //     "PhoneCode": "378",
            //     "CountryCode3Letter": "SMR"
            // },
            // {
            //     "CountryId": 204,
            //     "CountryCode": "SA",
            //     "CountryName": "Saudi Arabia",
            //     "PhoneCode": "966",
            //     "CountryCode3Letter": "SAU"
            // },
            {
                "CountryId": 205,
                "CountryCode": "SN",
                "CountryName": "Senegal",
                "PhoneCode": "221",
                "CountryCode3Letter": "SEN"
            },
            {
                "CountryId": 206,
                "CountryCode": "RS",
                "CountryName": "Serbia",
                "PhoneCode": "381",
                "CountryCode3Letter": "SRB"
            },
            {
                "CountryId": 207,
                "CountryCode": "CS",
                "CountryName": "Serbia and Montenegro",
                "PhoneCode": null,
                "CountryCode3Letter": null
            },
            // {
            //     "CountryId": 208,
            //     "CountryCode": "SC",
            //     "CountryName": "Seychelles",
            //     "PhoneCode": "248",
            //     "CountryCode3Letter": "SYC"
            // },
            // {
            //     "CountryId": 209,
            //     "CountryCode": "SL",
            //     "CountryName": "Sierra Leone",
            //     "PhoneCode": "232",
            //     "CountryCode3Letter": "SLE"
            // },
            {
                "CountryId": 210,
                "CountryCode": "SG",
                "CountryName": "Singapore",
                "PhoneCode": "65",
                "CountryCode3Letter": "SGP"
            },
            {
                "CountryId": 211,
                "CountryCode": "SK",
                "CountryName": "Slovakia",
                "PhoneCode": "421",
                "CountryCode3Letter": "SVK"
            },
            {
                "CountryId": 212,
                "CountryCode": "SI",
                "CountryName": "Slovenia",
                "PhoneCode": "386",
                "CountryCode3Letter": "SVN"
            },
            // {
            //     "CountryId": 213,
            //     "CountryCode": "SB",
            //     "CountryName": "Solomon Islands",
            //     "PhoneCode": "677",
            //     "CountryCode3Letter": "SLB"
            // },
            {
                "CountryId": 214,
                "CountryCode": "SO",
                "CountryName": "Somalia",
                "PhoneCode": "252",
                "CountryCode3Letter": "SOM"
            },
            // {
            //     "CountryId": 215,
            //     "CountryCode": "ZA",
            //     "CountryName": "South Africa",
            //     "PhoneCode": "27",
            //     "CountryCode3Letter": "ZAF"
            // },
            // {
            //     "CountryId": 216,
            //     "CountryCode": "GS",
            //     "CountryName": "South Georgia and the South Sandwich Islands",
            //     "PhoneCode": "500",
            //     "CountryCode3Letter": "SGS"
            // },
            // {
            //     "CountryId": 217,
            //     "CountryCode": "KR",
            //     "CountryName": "South Korea",
            //     "PhoneCode": "82",
            //     "CountryCode3Letter": "KOR"
            // },
            {
                "CountryId": 218,
                "CountryCode": "ES",
                "CountryName": "Spain",
                "PhoneCode": "34",
                "CountryCode3Letter": "ESP"
            },
            // {
            //     "CountryId": 219,
            //     "CountryCode": "LK",
            //     "CountryName": "Sri Lanka",
            //     "PhoneCode": "94",
            //     "CountryCode3Letter": "LKA"
            // },
            {
                "CountryId": 220,
                "CountryCode": "SD",
                "CountryName": "Sudan",
                "PhoneCode": "249",
                "CountryCode3Letter": "SDN"
            },
            {
                "CountryId": 221,
                "CountryCode": "SR",
                "CountryName": "Suriname",
                "PhoneCode": "597",
                "CountryCode3Letter": "SUR"
            },
            // {
            //     "CountryId": 222,
            //     "CountryCode": "SJ",
            //     "CountryName": "Svalbard and Jan Mayen",
            //     "PhoneCode": "4779",
            //     "CountryCode3Letter": "SJM"
            // },
            {
                "CountryId": 223,
                "CountryCode": "SZ",
                "CountryName": "Swaziland",
                "PhoneCode": "268",
                "CountryCode3Letter": "SWZ"
            },
            {
                "CountryId": 224,
                "CountryCode": "SE",
                "CountryName": "Sweden",
                "PhoneCode": "46",
                "CountryCode3Letter": "SWE"
            },
            {
                "CountryId": 225,
                "CountryCode": "CH",
                "CountryName": "Switzerland",
                "PhoneCode": "41",
                "CountryCode3Letter": "CHE"
            },
            {
                "CountryId": 226,
                "CountryCode": "SY",
                "CountryName": "Syria",
                "PhoneCode": "963",
                "CountryCode3Letter": "SYR"
            },
            // {
            //     "CountryId": 227,
            //     "CountryCode": "ST",
            //     "CountryName": "São Tomé and Príncipe",
            //     "PhoneCode": "239",
            //     "CountryCode3Letter": "STP"
            // },
            {
                "CountryId": 228,
                "CountryCode": "TW",
                "CountryName": "Taiwan",
                "PhoneCode": "886",
                "CountryCode3Letter": "TWN"
            },
            {
                "CountryId": 229,
                "CountryCode": "TJ",
                "CountryName": "Tajikistan",
                "PhoneCode": "992",
                "CountryCode3Letter": "TJK"
            },
            {
                "CountryId": 230,
                "CountryCode": "TZ",
                "CountryName": "Tanzania",
                "PhoneCode": "255",
                "CountryCode3Letter": "TZA"
            },
            {
                "CountryId": 231,
                "CountryCode": "TH",
                "CountryName": "Thailand",
                "PhoneCode": "66",
                "CountryCode3Letter": "THA"
            },
            {
                "CountryId": 232,
                "CountryCode": "TL",
                "CountryName": "Timor-Leste",
                "PhoneCode": "670",
                "CountryCode3Letter": "TLS"
            },
            {
                "CountryId": 233,
                "CountryCode": "TG",
                "CountryName": "Togo",
                "PhoneCode": "228",
                "CountryCode3Letter": "TGO"
            },
            // {
            //     "CountryId": 234,
            //     "CountryCode": "TK",
            //     "CountryName": "Tokelau",
            //     "PhoneCode": "690",
            //     "CountryCode3Letter": "TKL"
            // },
            {
                "CountryId": 235,
                "CountryCode": "TO",
                "CountryName": "Tonga",
                "PhoneCode": "676",
                "CountryCode3Letter": "TON"
            },
            // {
            //     "CountryId": 236,
            //     "CountryCode": "TT",
            //     "CountryName": "Trinidad and Tobago",
            //     "PhoneCode": "1868",
            //     "CountryCode3Letter": "TTO"
            // },
            {
                "CountryId": 237,
                "CountryCode": "TN",
                "CountryName": "Tunisia",
                "PhoneCode": "216",
                "CountryCode3Letter": "TUN"
            },
            {
                "CountryId": 238,
                "CountryCode": "TR",
                "CountryName": "Turkey",
                "PhoneCode": "90",
                "CountryCode3Letter": "TUR"
            },
            {
                "CountryId": 239,
                "CountryCode": "TM",
                "CountryName": "Turkmenistan",
                "PhoneCode": "993",
                "CountryCode3Letter": "TKM"
            },
            // {
            //     "CountryId": 240,
            //     "CountryCode": "TC",
            //     "CountryName": "Turks and Caicos Islands",
            //     "PhoneCode": "1649",
            //     "CountryCode3Letter": "TCA"
            // },
            {
                "CountryId": 241,
                "CountryCode": "TV",
                "CountryName": "Tuvalu",
                "PhoneCode": "688",
                "CountryCode3Letter": "TUV"
            },
            // {
            //     "CountryId": 242,
            //     "CountryCode": "UM",
            //     "CountryName": "U.S. Minor Outlying Islands",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": "UMI"
            // },
            // {
            //     "CountryId": 243,
            //     "CountryCode": "PU",
            //     "CountryName": "U.S. Miscellaneous Pacific Islands",
            //     "PhoneCode": null,
            //     "CountryCode3Letter": null
            // },
            // {
            //     "CountryId": 244,
            //     "CountryCode": "VI",
            //     "CountryName": "U.S. Virgin Islands",
            //     "PhoneCode": "1340",
            //     "CountryCode3Letter": "VIR"
            // },
            {
                "CountryId": 245,
                "CountryCode": "UG",
                "CountryName": "Uganda",
                "PhoneCode": "256",
                "CountryCode3Letter": "UGA"
            },
            {
                "CountryId": 246,
                "CountryCode": "UA",
                "CountryName": "Ukraine",
                "PhoneCode": "380",
                "CountryCode3Letter": "UKR"
            },
            // {
            //     "CountryId": 248,
            //     "CountryCode": "AE",
            //     "CountryName": "United Arab Emirates",
            //     "PhoneCode": "971",
            //     "CountryCode3Letter": "ARE"
            // },
            {
                "CountryId": 249,
                "CountryCode": "GB",
                "CountryName": "United Kingdom",
                "PhoneCode": "44",
                "CountryCode3Letter": "GBR"
            },
            {
                "CountryId": 250,
                "CountryCode": "US",
                "CountryName": "USA",
                "PhoneCode": "1",
                "CountryCode3Letter": "USA"
            },
            {
                "CountryId": 251,
                "CountryCode": "ZZ",
                "CountryName": "Unknown or Invalid Region",
                "PhoneCode": null,
                "CountryCode3Letter": null
            },
            {
                "CountryId": 252,
                "CountryCode": "UY",
                "CountryName": "Uruguay",
                "PhoneCode": "598",
                "CountryCode3Letter": "URY"
            },
            {
                "CountryId": 253,
                "CountryCode": "UZ",
                "CountryName": "Uzbekistan",
                "PhoneCode": "998",
                "CountryCode3Letter": "UZB"
            },
            {
                "CountryId": 254,
                "CountryCode": "VU",
                "CountryName": "Vanuatu",
                "PhoneCode": "678",
                "CountryCode3Letter": "VUT"
            },
            {
                "CountryId": 255,
                "CountryCode": "VA",
                "CountryName": "Vatican City",
                "PhoneCode": "379",
                "CountryCode3Letter": "VAT"
            },
            {
                "CountryId": 256,
                "CountryCode": "VE",
                "CountryName": "Venezuela",
                "PhoneCode": "58",
                "CountryCode3Letter": "VEN"
            },
            {
                "CountryId": 257,
                "CountryCode": "VN",
                "CountryName": "Vietnam",
                "PhoneCode": "84",
                "CountryCode3Letter": "VNM"
            },
            {
                "CountryId": 258,
                "CountryCode": "WK",
                "CountryName": "Wake Island",
                "PhoneCode": null,
                "CountryCode3Letter": null
            },
            {
                "CountryId": 259,
                "CountryCode": "WF",
                "CountryName": "Wallis and Futuna",
                "PhoneCode": "681",
                "CountryCode3Letter": "WLF"
            },
            {
                "CountryId": 260,
                "CountryCode": "EH",
                "CountryName": "Western Sahara",
                "PhoneCode": "212",
                "CountryCode3Letter": "ESH"
            },
            {
                "CountryId": 261,
                "CountryCode": "YE",
                "CountryName": "Yemen",
                "PhoneCode": "967",
                "CountryCode3Letter": "YEM"
            },
            {
                "CountryId": 262,
                "CountryCode": "ZM",
                "CountryName": "Zambia",
                "PhoneCode": "260",
                "CountryCode3Letter": "ZMB"
            },
            {
                "CountryId": 263,
                "CountryCode": "ZW",
                "CountryName": "Zimbabwe",
                "PhoneCode": "263",
                "CountryCode3Letter": "ZWE"
            },
            {
                "CountryId": 264,
                "CountryCode": "AX",
                "CountryName": "Åland Islands",
                "PhoneCode": "358",
                "CountryCode3Letter": "ALA"
            },
            {
                "CountryId": 265,
                "CountryCode": "AF",
                "CountryName": "Afghanistan",
                "PhoneCode": "93",
                "CountryCode3Letter": "AFG"
            },
            {
                "CountryId": 266,
                "CountryCode": "MO",
                "CountryName": "Macao",
                "PhoneCode": "853",
                "CountryCode3Letter": "MAC"
            },
            {
                "CountryId": 728,
                "CountryCode": "SS",
                "CountryName": "South Sudan",
                "PhoneCode": "211",
                "CountryCode3Letter": "SSD"
            }
        ],
    },
})
